<template>
  <div :class="$style.Container">
    <div
      :class="$style.Channel"
      v-for="channel in channels"
      :key="channel.value"
      @click="emits('update:value', channel.value)"
    >
      <div><img :src="channel.imgUrl" />{{ channel.label }}</div>
      <img
        v-show="props.value === channel.value"
        src="https://static.lingvisions.com/public/e77e7dac89a44fd29606c1db3b1928a0.png"
        :class="$style.Check"
    /></div>
  </div>
</template>

<script lang="ts" setup>
  import { PAY_CHANNEL } from '../constants';

  const props = defineProps({
    value: {
      type: String,
      required: true,
    },
  });
  const emits = defineEmits('update:value');
  const channels = [
    {
      label: '微信',
      value: PAY_CHANNEL.WECHAT,
      imgUrl:
        'https://static.lingvisions.com/public/d97e1e91f9ef470084bb431f6c8b73e3.png',
    },
    {
      label: '支付宝',
      value: PAY_CHANNEL.ALIPAY,
      imgUrl:
        'https://static.lingvisions.com/public/92367019a65042d88c092d1ba5867447.png',
    },
  ];
</script>

<style lang="less" module>
  .Container {
    border-radius: 6px;
    overflow: hidden;
  }

  .Channel {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: rgba(255, 255, 255, 0.85);
    background-color: rgba(255, 255, 255, 0.04);
    margin-bottom: 1px;

    > div {
      display: flex;
      align-items: center;

      img {
        width: 20px;
        height: 20px;
        margin-right: 12px;
      }
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .Check {
    width: 16px;
    height: 16px;
  }
</style>
